export default __webpack_public_path__ + "static/media/ajaykalla.9349aab0.jpg";